import { useTranslation } from "react-i18next";
import exportAllExports from "./Export/exportAllExports";
import {
  useGetUserRegistrationsFullQuery,
  useGetUsersPerMonthQuery,
} from "../../services/API/statisticsAPI";
import { Bar } from "react-chartjs-2";
import ChartCard from "./ChartCard";
import CsvDownloadButton from "./CsvDownloadButton";
import { baseOptions, monthlyScales, nullifyFutureMonths, yearBarDataset } from "./chartTheme";

const RegistartionsPerMonthStats = () => {
  const { t } = useTranslation(["translation", "statistics"]);
  const todayYear = new Date().getFullYear();

  // The API ignores query params on these endpoints — every caller passes
  // undefined so all components share one cache entry per endpoint
  const { data: usersPerMonth, isLoading } = useGetUsersPerMonthQuery(undefined, {
    pollingInterval: 60000,
  });

  const { data: userRegistrationsFullData } = useGetUserRegistrationsFullQuery(undefined, {
    pollingInterval: 60000,
  });

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Plot the two most recent years that have data; fall back to the
  // current year so an empty chart still renders with axes
  let years = [
    ...new Set(
      (usersPerMonth ?? []).filter((item) => item?._id?.year).map((item) => item._id.year)
    ),
  ]
    .sort((a, b) => b - a)
    .slice(0, 2);
  if (years.length === 0) years = [todayYear];

  const datasetData = years.map(() => new Array(12).fill(0));

  usersPerMonth?.map((item) => {
    const yearIndex = years.indexOf(item?._id?.year);
    if (yearIndex === -1) return null;

    datasetData[yearIndex][item._id.month - 1] = item.count;
    return null;
  });

  const dataUserPerJear = {
    labels,
    datasets: [],
  };

  // Oldest year first so grouped bars read chronologically left to right
  [...years].reverse().forEach((year) => {
    const yearIndex = years.indexOf(year);
    dataUserPerJear.datasets.push(
      yearBarDataset({
        label: year.toString(),
        data:
          year === todayYear ? nullifyFutureMonths(datasetData[yearIndex]) : datasetData[yearIndex],
        isCurrentYear: yearIndex === 0,
      })
    );
  });

  const options = {
    ...baseOptions(),
    scales: monthlyScales(),
  };

  return (
    <ChartCard
      title={t("user.neuregistrierungennachlaender", { ns: "statistics" })}
      action={
        <CsvDownloadButton
          data={exportAllExports?.exportRegistrationsFull(userRegistrationsFullData ?? [])}
          headers={exportAllExports.headersRegistrationsFull()}
          filename={"stats_registrations_full.csv"}
        />
      }
    >
      {isLoading ? (
        <div>{t("general.loading", { ns: "statistics" })}</div>
      ) : (
        <Bar options={options} data={dataUserPerJear} />
      )}
    </ChartCard>
  );
};

export default RegistartionsPerMonthStats;
